import { FormConfig } from '@domgen/dgx-fe-forms/shared';
import { AppConfig } from '../../models/config/app-config.type';

export const formConfigFactory = (
  config: AppConfig
): FormConfig | undefined => {
  if (!config.form) {
    return undefined;
  }

  return {
    clpEnabled: config.form.clpEnabled,
    optionalHidden: config.form.optionalHidden,
    requiredHidden: config.form.requiredHidden,
    wibApi: config.wibApi,
  };
};
